export default __webpack_public_path__ + "static/media/small-phone.c5a66b11.svg";